"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.bradford.description': 'British storyteller, expressive and engaging.',
};
